import { smsTemplatePopulatedSchema } from "@redotech/redo-model/sms-template";
import * as z from "zod/v4";

export const updateSmsTemplate = {
  name: "updateSmsTemplate" as const,
  input: z.object({
    id: z.string(),
    template: smsTemplatePopulatedSchema.omit({ _id: true }),
  }),
  output: z.null(),
};
